import { ApiServiceBase } from './apiServiceBase';

export class CategoriesService extends ApiServiceBase {
    private apiUrl = '/api/bookmarkcategories/1.0';
    private categoriesWithAppendedBookmarksUrl = '/api/bookmarks/1.0/category';
    getCategories(onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(this.categoriesWithAppendedBookmarksUrl, onSuccess, onFailure);
    }

    deleteCategory(category, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.delete(`${this.apiUrl}/${category.categoryId}`, onSuccess, onFailure);
    }

    createCategory(category, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.post(this.apiUrl, onSuccess, onFailure, category);
    }

    editCategory(category, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.apiUrl}/${category.categoryId}`, onSuccess, onFailure, category);
    }
}